import { render } from "./Welcome.vue?vue&type=template&id=582c2f6d&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=582c2f6d&scoped=true&lang=css"

import exportComponent from "/Users/magsin/Projects/sommarfest2022/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582c2f6d"]])

export default __exports__